import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconMusic } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface MusicVideoListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const MusicVideoListItem: React.FC<MusicVideoListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconMusic}
    typeLabel="Music Video"
    testId="music-video-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.WATCH }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default MusicVideoListItem
